/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "ScheduleTablePageService";
const log: any = LoggerModule.getInstance();

export class ScheduleTablePageService {
  private static instance: ScheduleTablePageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): ScheduleTablePageService {
    if (!ScheduleTablePageService.instance) {
      ScheduleTablePageService.instance = new ScheduleTablePageService(props);
    }
    return ScheduleTablePageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getScheduleList({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log(`content bla : `, content);
    return content;
  }

  public async resendMail(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.resendMail(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getSchedulesReport(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getSchedulesReport(arg);
    return content;
  }
}
